import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Required permissions missing!", -1)
const _hoisted_2 = { class: "dialog-content pb-3" }
const _hoisted_3 = { class: "facebook-connect-alert__content" }
const _hoisted_4 = { class: "facebook-rights__list" }
const _hoisted_5 = { class: "facebook-rights__item" }
const _hoisted_6 = { class: "dialog-actions mt-0" }

import { useDialogStore } from '@/stores/dialogs';
import { useFacebookStore } from '@/stores/facebook';
import { useUiStore } from '@/stores/ui';
import { ref } from 'vue';
import VButton from '../VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacebookRightsAlert',
  props: {
    permissions: null
  },
  setup(__props: any) {

const props = __props as { permissions: string[] }


const dialogStore = useDialogStore()
const facebookStore = useFacebookStore()
const uiStore = useUiStore()

const pending = ref(false)
const tryAgain = async () => {
  pending.value = true
  try {
    await facebookStore.connectFacebook()
  } catch {
    pending.value = false
  }
}

const cancel = () => {
  uiStore.showFacebookAlert = true
  dialogStore.close()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" It seems that the necessary permissions were not granted. "),
        (props.permissions && props.permissions.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Kindly ensure that you allow the following " + _toDisplayString(props.permissions.length === 1? "permisson": "permissons") + ": ", 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.permissions, (permisson) => {
          return (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(permisson), 1))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(VButton, {
        disabled: pending.value,
        onClick: tryAgain
      }, {
        default: _withCtx(() => [
          _createTextVNode("Try again")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(VButton, {
        onClick: cancel,
        secondary: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("Cancel")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})